<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable max-width="800px" persistent>
      <v-card>
        <v-card-title>Select Output Document</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-radio-group
            v-model="dialogm1"
            column
            v-for="document in allOutputDocuments"
            :key="document.id"
          >
            <v-radio :label="document.documentDetails.name" :value="document">
              <template v-slot:label>
                <div class=" mr-2">
                  <!-- <strong class="success--text">{{ document.documentDetails.name }}</strong> -->
                  from
                  <b class="indigo--text">
                    {{ document.route_details.action.name }}
                  </b>
                  {{
                    document.isInitiatorRoute
                      ? "initiator route "
                      : "sub-route "
                  }}
                </div>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-on="on"
                      v-bind="attrs"
                      @click="
                        viewDocument(document.document_route.filepath_url)
                      "
                      class="mr-2"
                    >
                      mdi-image
                    </v-icon>
                  </template>
                  <span>View Document</span>
                </v-tooltip>
                -- by
                <b class="success--text ml-2">
                  {{
                    ` ${document.uploaded_by.first_name} ${document.uploaded_by.middle_name} ${document.uploaded_by.last_name}`
                  }}
                </b>
              </template>
            </v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="closeDialog()">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="selectDocument()">
            Select
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { fileSystemUrl } from '../../config/config.json';

export default {
  name: "OutputDocumentDialog",
  props: {
    dialog: Boolean,
    initiatorId: Number,
    routeId: Number,
    routeType: String,
  },
  data() {
    return {
      dialogm1: "",
    };
  },
  methods: {
    ...mapActions(["fetchOutputDocuments"]),
    closeDialog() {
      this.dialogm1 = "";
      this.$emit("closeDialog", false);
    },
    selectDocument() {
      this.$emit("referenceDocument", this.dialogm1);
      this.dialogm1 = "";
    },
    viewDocument(val) {
      open(`${fileSystemUrl}/view/${val}`);
    },
  },
  computed: mapGetters(["allOutputDocuments"]),
  watch: {
    dialog: function() {
      if (this.dialog) {
        this.fetchOutputDocuments({
          route_type: this.routeType,
          route_id: this.routeId,
          initiator_id: this.initiatorId,
        });
      }
    },
  },
};
</script>

<style></style>
